import Work1 from "../../assets/work1.jpg";
import Work2 from "../../assets/work2.jpg";
import Work3 from "../../assets/work3.jpg";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";
import Work6 from "../../assets/work6.jpg";
import Work7 from "../../assets/work7.jpg";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "BOM Computation Engine",
    description:
      "Built a custom SAP ABAP application to automate full bill-of-materials breakdowns and material cost computation for a manufacturing client, replacing a manual calculation process end-to-end.",
    link: "https://drive.google.com/file/d/1y9VRzThFugE0o4nFxbJwunbMIv_7jlmx/view?usp=sharing",
  },
  {
    id: 2,
    image: Work2,
    title: "HVAC Manufacturer — ERP Reorg & GST Migration",
    description:
      "Designed and executed migration programs to move millions of sales orders, purchase orders, and inventory records across plants during a major billing and GST reconciliation restructure.",
    link: "https://drive.google.com/file/d/1LQ7l9HVfJ2qfEAU-ueGNJuSWEZKwBGfl/view?usp=share_link",
  },
  {
    id: 3,
    image: Work3,
    title: "Pharma Client — Quality Management Platform",
    description:
      "Built the OData API layer and SAP Fiori application for a pharma client's web-based QM system, connecting quality assessment processes directly to SAP in real time.",
    link: "https://drive.google.com/file/d/1KGFn76r3GYT3NaEzTgDeHWsV6Yyj00uN/view?usp=sharing",
  },
  {
    id: 4,
    image: Work4,
    title: "Global Electronics Brand — Unified Approval Platform",
    description:
      "Built an all-in-one approval application for senior management at a global electronics brand, consolidating multi-screen approval workflows into a single interface and dramatically cutting decision turnaround time.",
    link: "https://drive.google.com/file/d/1KGFn76r3GYT3NaEzTgDeHWsV6Yyj00uN/view?usp=sharing",
  },
  {
    id: 5,
    image: Work5,
    title: "HR Claims → SAP Finance Integration",
    description:
      "Designed and built an API to post employee expense claims and HR settlements from a third-party platform directly into the SAP General Ledger — fully automating a manual finance reconciliation process.",
    link: "https://drive.google.com/file/d/1y9VRzThFugE0o4nFxbJwunbMIv_7jlmx/view?usp=sharing",
  },
  {
    id: 6,
    image: Work6,
    title: "Govt. Education Agency — International Student Portal",
    description:
      "Delivered a React Native mobile app for a government client enabling international students to discover and register for colleges across India.",
    link: "https://drive.google.com/file/d/1LQ7l9HVfJ2qfEAU-ueGNJuSWEZKwBGfl/view?usp=share_link",
  },
  {
    id: 7,
    image: Work7,
    title: "Large Retail Chain — HR Lead Management Fix",
    description:
      "Diagnosed and resolved a years-old broken HR lead management module for India's largest retail chain — fixing core SAP enhancements and API logic the previous team couldn't crack.",
    link: "https://drive.google.com/file/d/1KGFn76r3GYT3NaEzTgDeHWsV6Yyj00uN/view?usp=sharing",
  },
];
